import { useMutation, useQueryClient } from '@tanstack/react-query';

import ErrorHandler from '../../components/ErrorHandler';
import { ApiError } from '../../types/Error';
import { ScanRes } from '../../types/Scan';
import { createScan } from '../Scans';

export const useCreateScan = (onSuccess?: (data: ScanRes) => void, onError?: (error: ApiError) => void) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createScan,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['scans'] });
            onSuccess?.(data);
        },
        onError: (error: ApiError) => {
            ErrorHandler(error);
            onError?.(error);
        }
    });
};
